/* @minVersion 7.17.0 */

export default function _identity(x) {
  return x;
}
